const DROPDOWN_LIMIT = 100;
const CHIP_LIMIT = 100;

function mapOptionValue(value) {
  return String(value);
}

function filterOptionsByQuery(options, query) {
  if (!query) {
    return options;
  }
  const normalized = query.toLowerCase();
  return options.filter((item) => item.text.toLowerCase().includes(normalized));
}

export default {
  data() {
    return {
      binPicker: {
        options: [],
        selected: [],
        checkAll: false,
        searchQuery: '',
        searchTimeout: null,
        loading: '',
        allLabel: 'ALL Bins'
      }
    };
  },
  computed: {
    binPickerUi() {
      const picker = this.binPicker;
      const query = (picker.searchQuery || '').trim();
      const queryLower = query.toLowerCase();
      const filtered = filterOptionsByQuery(picker.options, queryLower);
      const searchActive = query.length > 0;
      const searchItems = searchActive ? filtered : picker.options;
      const selectedSet = new Set(picker.selected.map((item) => mapOptionValue(item.value)));

      return {
        hasSelection: picker.checkAll || picker.selected.length > 0,
        summaryLabel: picker.checkAll
          ? (picker.options.length > 0 ? `${picker.allLabel} (${picker.options.length})` : picker.allLabel)
          : null,
        displayedChips: picker.selected.slice(0, CHIP_LIMIT),
        remainingChips: Math.max(0, picker.selected.length - CHIP_LIMIT),
        dropdownOptions: filtered.slice(0, DROPDOWN_LIMIT),
        dropdownTruncated: filtered.length > DROPDOWN_LIMIT,
        dropdownTotal: filtered.length,
        searchActionCount: searchItems.length,
        hasActiveSearch: searchActive,
        searchItems,
        selectedSet
      };
    }
  },
  beforeDestroy() {
    this.binPickerClearSearchTimeout();
  },
  methods: {
    binPickerClearSearchTimeout() {
      if (this.binPicker.searchTimeout) {
        clearTimeout(this.binPicker.searchTimeout);
        this.binPicker.searchTimeout = null;
      }
    },

    binPickerReset() {
      this.binPicker.selected = [];
      this.binPicker.checkAll = false;
      this.binPicker.searchQuery = '';
    },

    binPickerOnSearchChange(query) {
      this.binPickerClearSearchTimeout();
      this.binPicker.searchTimeout = setTimeout(() => {
        this.binPicker.searchQuery = (query || '').trim();
        this.binPicker.searchTimeout = null;
      }, 250);
    },

    binPickerIsSelected(option) {
      if (this.binPicker.checkAll) {
        return true;
      }
      return this.binPickerUi.selectedSet.has(mapOptionValue(option.value));
    },

    binPickerToggleOption(option) {
      if (this.binPicker.checkAll) {
        return;
      }
      const multiselect = this.$refs.binPickerMultiselect;
      if (!multiselect) {
        return;
      }
      if (this.binPickerIsSelected(option)) {
        multiselect.remove(option);
      } else {
        multiselect.select(option);
      }
    },

    binPickerRemoveChip(option) {
      const multiselect = this.$refs.binPickerMultiselect;
      if (multiselect && typeof multiselect.remove === 'function') {
        multiselect.remove(option);
        return;
      }
      this.binPicker.selected = this.binPicker.selected.filter(
        (item) => mapOptionValue(item.value) !== mapOptionValue(option.value)
      );
      this.binPickerSyncCheckAll();
    },

    binPickerToggleCheckAll() {
      if (this.binPicker.options.length === 0) {
        return;
      }
      if (this.binPicker.checkAll || this.binPicker.selected.length === this.binPicker.options.length) {
        this.binPickerReset();
        return;
      }
      this.binPicker.checkAll = true;
      this.binPicker.selected = [];
    },

    binPickerBulkSelect(selectAll) {
      const ui = this.binPickerUi;
      if (this.binPicker.checkAll) {
        return;
      }
      if (selectAll) {
        if (!ui.hasActiveSearch || ui.searchItems.length === this.binPicker.options.length) {
          if (this.binPicker.options.length === 0) {
            return;
          }
          this.binPicker.checkAll = true;
          this.binPicker.selected = [];
          return;
        }
        const toAdd = ui.searchItems.filter((item) => !ui.selectedSet.has(mapOptionValue(item.value)));
        if (toAdd.length > 0) {
          this.binPicker.selected = this.binPicker.selected.concat(toAdd);
        }
      } else if (ui.hasActiveSearch) {
        const filteredSet = new Set(ui.searchItems.map((item) => mapOptionValue(item.value)));
        this.binPicker.selected = this.binPicker.selected.filter(
          (item) => !filteredSet.has(mapOptionValue(item.value))
        );
      }
      this.binPickerSyncCheckAll();
    },

    binPickerSyncCheckAll() {
      if (this.binPicker.checkAll) {
        return;
      }
      const total = this.binPicker.options.length;
      if (total > 0 && this.binPicker.selected.length === total) {
        this.binPicker.checkAll = true;
        this.binPicker.selected = [];
      }
    },

    binPickerSelectedValues() {
      if (this.binPicker.checkAll || this.binPicker.selected.length === 0) {
        return null;
      }
      return this.binPicker.selected.map((item) => item.value);
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/Palletization/shared/binMultiselectFilterMixin.js